import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-rain': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 128C415.4 128 414.9 128.2 414.4 128.2 415.5 123 416 117.6 416 112 416 67.8 380.2 32 336 32 311.4 32 289.7 43.3 275 60.8 256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112 64 119.3 64.8 126.3 66.1 133.2 27.8 145.8 0 181.5 0 224 0 277 43 320 96 320H416C469 320 512 277 512 224S469 128 416 128zM88 374.2C75.2 418.6 48 430.6 48 461.9 48 489.6 69.5 512 96 512S144 489.6 144 461.9C144 430.5 116.8 418.8 104 374.2 101.8 366.1 90.5 365.7 88 374.2zM248 374.2C235.2 418.6 208 430.6 208 461.9 208 489.6 229.5 512 256 512S304 489.6 304 461.9C304 430.5 276.8 418.8 264 374.2 261.8 366.1 250.5 365.7 248 374.2zM408 374.2C395.2 418.6 368 430.6 368 461.9 368 489.6 389.5 512 416 512S464 489.6 464 461.9C464 430.5 436.8 418.8 424 374.2 421.8 366.1 410.5 365.7 408 374.2z'
      }
    ]
  }
})
